import { Box, Columns, Column } from 'braid-design-system';

interface Props {
  imageUrl: string;
  children?: React.ReactNode;
}

export const ImageBanner = ({ imageUrl, children }: Props) => (
  <Box background="body">
    <Columns reverse space="none" collapseBelow="desktop">
      <Column>
        <Box
          height="full"
          width="full"
          role="img"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: 230,
          }}
          src={imageUrl}
        />
      </Column>
      <Column width="1/2">
        <Box padding="large" paddingY={{ mobile: 'large', desktop: 'xxlarge' }}>
          {children}
        </Box>
      </Column>
    </Columns>
  </Box>
);
